import React, { useState } from 'react'
import { Link } from 'react-router-dom'
// import ViewProps from '../types/ViewProps'
import Typed from './Typed'

interface SegmentProps {
  children: React.ReactNode,
  delay: number,
  duration: number,
}

export const Segment = ({ children, delay, duration }: SegmentProps) => {
  const [ show, setShow ] = useState<boolean>(false)
  // setTimeout(() => setShow(true), time)
  return (
    <span className="segment" style={{
      animationDuration: `${duration}ms`,
      animationDelay: `${delay}ms`,
    }}>{children}</span>
  )
}

export default ({ children }: { children: string | React.ReactNodeArray }) => {
  if (typeof children === 'string') {
    children = children.split(' ')
  }
  else {
    children = children.map(e => typeof e === "string" ? e.trim().split(' ') : e).flat()
  }
  let timeline = 600

  return (
    <>
      {children.map((n: any, index) => {
        const hasSegmentProps = typeof n !== 'string'
        const element = <Segment key={timeline} delay={timeline} duration={hasSegmentProps ? n.props.duration: 175}>{n} </Segment>
        timeline += hasSegmentProps ? n.props.delay : 135
        return element
      })}
    </>
  )

}